module.exports = __webpack_public_path__ + "img/grp decline.ab7a578a.png";